// src/pages/Article.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import '../css/Article.css';

const articles = {
    'simple-to-manage': {
      title: 'Simple to manage your services and add to it',
      date: '24 April',
      content: `
  Managing your services has never been easier. With our latest dashboard update, you can:
  - Easily add or remove services
  - Monitor performance metrics
  - Collaborate with your team in real-time
  
  Everything is designed to give you more control with fewer steps. Explore intuitive workflows and a modern interface tailored for businesses of all sizes. Empower your brand by staying organized and proactive.
      `,
    },
    'introducing-solutions': {
      title: 'Introducing — Solutions',
      date: '24 April',
      content: `
  Say hello to our new 'Solutions' section — curated service bundles designed to solve real business challenges.
  
  We’ve grouped our most requested offerings into logical packages like:
  - Digital Branding Starter
  - Social Buzz & Reels Powerhouse
  - Advanced Web + App Kits
  
  Now you can skip the guesswork and pick a solution tailored for growth, visibility, and engagement. Whether you're a startup or a scaling business, there's a solution for every stage.
      `,
    },
    'major-updates': {
      title: 'Major updates to make your branding process',
      date: '24 April',
      content: `
  We’ve made significant upgrades to our branding workflow, all aimed at simplifying the way you scale your identity online.
  
  🔄 What's new:
  - Automated brand guideline generation
  - Integrated motion design tools
  - Cross-platform preview system
  - AI-assisted content suggestions
  
  Your brand deserves agility, speed, and consistency. With these updates, our platform is now faster, smarter, and more aligned with your creative goals.
      `,
    },
  };
  

const Article = () => {
  const { id } = useParams();
  const article = articles[id];

  if (!article) return <h2>Article not found</h2>;

  return (
    <div className="article-container">
      <h1>{article.title}</h1>
      <p className="article-date">{article.date}</p>
      <div className="article-content">{article.content}</div>
    </div>
  );
};

export default Article;
